<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.evaluacion' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="yearChange($event)"
    [click]="false"
  />
  <app-filters filtros
    [name]="'filtros.sucursales' | translate"
    [array]="sucursales"
    [typeFilter]="Filters.SUCURSALES"
    [consolidado]="sucursalConsolidado"
    (eventClick)="sucursalChange($event)"
    [click]="false"
  />
  <app-filters filtros
    [name]="'filtros.dimensiones' | translate"
    [array]="dimensiones"
    [typeFilter]="Filters.SUCURSALES"
    [consolidado]="dimensionConsolidado"
    (eventClick)="dimensionChange($event)"
    [click]="false"
  />

  <div borrador>
    <div class="w3-button w3-dropdown-click iconoBorrarFiltros"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="borrarFiltros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>

  <div contenido class="spacePrincipal">
    @if (loadingResultados) {
      <div class="spinner-overlay">
        <div class="spinner-css"></div>
      </div>
    }
    @if (chips.length) {
      <div class="chipsFiltros">
        @for (chip of chips; track chip.texto) {
          <div class="chip">
            <span>{{ chip.texto }}</span>
            <span class="quitar" (click)="quitarChip(chip)">&times;</span>
          </div>
        }
      </div>
    }

    <div class="leftSide">
      @for (fila of filasGraficos; track $index) {
        <div class="filaZonas">
          @for (g of fila; track g.zona) {
            <div class="miniZone w3-white">
              <div class="encabezadoZonas">
                <div class="titulo">
                  {{ g.titulo | translate }} |
                  {{ segmentoSeleccion }}{{ periodoTitulo ? ' · ' + periodoTitulo : '' }}
                </div>
                <div class="iconosGrafica">
                  @if (g.type !== types.TABLE) {
                    <mat-icon class="iconoMen" (click)="g.etiquetas = !g.etiquetas"
                      matTooltip="{{ (g.etiquetas ? 'graf.desactivar' : 'graf.activar') | translate }}">
                      {{ g.etiquetas ? 'label_off' : 'label' }}
                    </mat-icon>
                  }
                  <mat-icon class="iconoMen" (click)="abrirModal(g)" matTooltip="{{ 'graf.ampliar' | translate }}">
                    zoom_out_map
                  </mat-icon>
                  <mat-icon class="iconoMen" [matMenuTriggerFor]="menuGrafico">more_vert</mat-icon>
                  <mat-menu #menuGrafico="matMenu">
                    <button mat-menu-item [matMenuTriggerFor]="menuTipos">
                      <mat-icon class="iconoGris">assessment</mat-icon>
                      <span>{{ 'graf.graficas' | translate }}</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="exportarGrafico(g)">
                      <mat-icon class="iconoGris">{{ g.type === types.TABLE ? 'description' : 'image' }}</mat-icon>
                      <span>{{ 'menu.Exportar' | translate }}</span>
                    </button>
                  </mat-menu>
                  <mat-menu #menuTipos="matMenu">
                    @for (tipo of g.tipos; track tipo) {
                      <button mat-menu-item (click)="cambiarTipo(g, tipo)" [disabled]="g.type === tipo">
                        <mat-icon class="iconoGris">{{ infoTipos[tipo].icono }}</mat-icon>
                        <span>{{ infoTipos[tipo].texto | translate }}</span>
                      </button>
                    }
                  </mat-menu>
                </div>
              </div>
              <div class="bodyZonas">
                @if (loadingResultados) {
                  @if (g.type === types.TABLE) {
                    <app-skeleton-table [filas]="6" [columnas]="3" />
                  } @else {
                    <app-skeleton-grafica [barras]="labelsDe(g.zona).length || 5" [leyendas]="2" />
                  }
                } @else if (g.type !== types.TABLE) {
                  <app-graficador
                    [zona]="g.zona * 10 + 1"
                    [data]="datosDe(g).data"
                    [labels]="datosDe(g).labels"
                    [type]="g.type"
                    [colors]="datosDe(g).colores"
                    [axisX]="''"
                    [axisY]="datosDe(g).axisY"
                    [etiquetas]="g.etiquetas"
                    [formatEtiquetas]="formatoEtiquetas(g)"
                    [distributed]="distribuida(g)"
                    [legend]="g.type === types.HEATMAP ? leyendaOculta : leyendaVisible"
                    (eventClick)="clickGraf(g, $event)"
                  />
                } @else {
                  <ng-container [ngTemplateOutlet]="tablaGrafico" [ngTemplateOutletContext]="{ zona: g.zona }" />
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</app-esqueleto-tableros>

@for (g of graficos; track g.zona) {
  <app-modal [isOpen]="g.ampliado" (close)="g.ampliado = false" [export]="true"
    [iconoExport]="g.type === types.TABLE ? 'description' : 'image'" (exportFile)="exportarGrafico(g)">
    <div modal-header>
      <span class="w3-titulo-contenidomenuSC">{{ g.titulo | translate }}</span>
      <span class="w3-margin-left-contenido w3-titulo-contenidomenuSC">&bull;</span>
      <span class="w3-margin-left-filter w3-subtitulo">{{ segmentoSeleccion }}{{ periodoTitulo ? ' · ' + periodoTitulo : '' }}</span>
    </div>
    <div modal-body>
      <div class="spaceGrafica">
        @if (g.type !== types.TABLE) {
          <div class="zonaGrafAmp">
            @if (g.ampliado) {
              <app-graficador
                [zona]="g.zona * 10 + 2"
                [data]="datosDe(g).data"
                [labels]="datosDe(g).labels"
                [type]="g.type"
                [colors]="datosDe(g).colores"
                [axisX]="''"
                [axisY]="datosDe(g).axisY"
                [etiquetas]="g.etiquetas"
                [formatEtiquetas]="formatoEtiquetas(g)"
                [distributed]="distribuida(g)"
                [legend]="g.type === types.HEATMAP ? leyendaOculta : leyendaVisible"
              />
            }
          </div>
        } @else {
          <ng-container [ngTemplateOutlet]="tablaGrafico" [ngTemplateOutletContext]="{ zona: g.zona }" />
        }
      </div>
    </div>
  </app-modal>
}

<ng-template #tablaGrafico let-zona="zona">
  @if (tablaDe(zona); as tabla) {
    <div class="w3-scroll tablaPerfil">
      <table class="w3-table borderInfLow">
        <thead>
          <tr class="w3-center w3-table-title">
            <th class="stikyColum w3-border-right-balance"></th>
            <th class="stikyColum w3-border-right-balance">{{ tabla.name }}</th>
            <th class="stikyColum w3-border-right-balance">%</th>
          </tr>
        </thead>
        <tbody>
          @for (label of labelsDe(zona); track label; let i = $index) {
            <tr class="w3-table-trtd">
              <td class="borderAllLow">{{ label }}</td>
              <td class="borderAllLow alinRight marginDer">{{ tabla.valores[i] }}</td>
              <td class="borderAllLow alinRight marginDer">{{ tabla.porcentaje[i] }} %</td>
            </tr>
          }
          <tr class="w3-table-titleLow">
            <td class="borderAllLow">{{ 'cues.perfil-clima.total' | translate }}</td>
            <td class="borderAllLow alinRight marginDer">{{ tabla.total }}</td>
            <td class="borderAllLow alinRight marginDer">100 %</td>
          </tr>
        </tbody>
      </table>
    </div>
  }
</ng-template>
